<template>
  <div>
    <div class="accountmanager">
      <el-table
        ref="multipleTable"
        :data="targetData.list"
        v-loading.body="loading"
        style="width: 100%"
        row-key="id"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column label="已用金额" prop="amount"></el-table-column>
        <el-table-column label="可用金额" prop="balance"></el-table-column>
        <el-table-column label="时间">
          <template scope="scope">
            {{ scope.row.create_time | timeFormat }}
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="note"> </el-table-column>
      </el-table>
      <div class="rb-table-pager">
        <el-pagination
          background
          :page-size="params.pageSize"
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page="parseInt(targetData.currentpage)"
          layout="total,sizes,prev, pager, next, jumper"
          :total="parseInt(targetData.total)"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "PayRecords", //支付记录
  data() {
    return {
      targetData: [],
      tableHeight: 100,
      loading: false,
      params: {
        pageNo: 1,
        pageSize: 10,
      },
    };
  },
  mounted() {
    this.getAccountFun();
  },
  methods: {
    getAccountFun() {
      this.$api.get("/api/cashaccount/cashPayRecords", this.params, (res) => {
        this.targetData = res.data;
      });
    },
    sizeChange(e) {
      this.params.pageSize = e;
      this.getAccountFun();
    },
    currentChange(e) {
      this.params.pageNo = e;
      this.getAccountFun();
    },
  },
};
</script>
<style lang="scss" scoped>
.accountmanager {
  background: #fff;
  min-height: 600px;
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// PayRecords.vue?4bc5859e